(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  let frame = 0;

  function buildSortControl(main) {
    if (!mobileQuery.matches) return;

    const target = main.querySelector('.facets-toggle .facets-mobile-wrapper');
    const source = main.querySelector('#filters-drawer sorting-filter-component select[name="sort_by"]');
    if (!target || !source) return;

    let shell = target.querySelector('[data-fj-mobile-sort]');
    if (!shell) {
      shell = document.createElement('div');
      shell.className = 'fj-mobile-sort';
      shell.dataset.fjMobileSort = 'true';
      shell.innerHTML = `
        <label class="fj-mobile-sort__label">Sort</label>
        <span class="fj-mobile-sort__select-wrap">
          <select class="fj-mobile-sort__select" aria-label="Sort products"></select>
          <svg class="fj-mobile-sort__caret" viewBox="0 0 12 8" fill="none" aria-hidden="true">
            <path d="m1.5 1.5 4.5 4.5 4.5-4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>`;
      target.appendChild(shell);
    }

    const control = shell.querySelector('select');
    if (!(control instanceof HTMLSelectElement)) return;

    const signature = Array.from(source.options)
      .map((option) => `${option.value}:${option.textContent || ''}`)
      .join('|');

    if (control.dataset.sourceSignature !== signature) {
      control.innerHTML = '';
      Array.from(source.options).forEach((option) => {
        control.appendChild(option.cloneNode(true));
      });
      control.dataset.sourceSignature = signature;
    }

    control.value = source.value;

    if (control.dataset.fjBound !== 'true') {
      control.dataset.fjBound = 'true';
      control.addEventListener('change', () => {
        const currentSource = main.querySelector('#filters-drawer sorting-filter-component select[name="sort_by"]');
        if (!(currentSource instanceof HTMLSelectElement)) return;

        currentSource.value = control.value;
        currentSource.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  function sync() {
    document.querySelectorAll("main[data-template^='collection']").forEach(buildSortControl);
  }

  function schedule() {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(sync);
  }

  function init() {
    sync();

    const root = document.getElementById('MainContent') || document.body;
    const observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true });

    mobileQuery.addEventListener?.('change', schedule);
    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
